export default __webpack_public_path__ + "static/media/logosf.c4d83d97.png";